export const Paths = {
  rdp: (restaurant: { linkedCity: { fullnameLower: string }; keyname: string }) =>
    `/${restaurant.linkedCity.fullnameLower}/restaurant/${restaurant.keyname}`,

  cityListing: (city: string) => `https://www.speisekarte.de/${city}/restaurants`,

  cityListingCuisine: (city: string, cuisineKeyname: string) =>
    `https://www.speisekarte.de/${city}/restaurants/${cuisineKeyname}`,

  restaurantFeedback: (city: string, restaurantKeyname: string) =>
    `https://www.speisekarte.de/${city}/restaurant/${restaurantKeyname}/fehler_melden`,

  restaurantReview: (city: string, restaurantKeyname: string) =>
    `https://www.speisekarte.de/${city}/restaurant/${restaurantKeyname}/bewertung`
};
